import { render, staticRenderFns } from "./proxy-control-config.vue?vue&type=template&id=c86d8c6e&scoped=true"
import script from "./proxy-control-config.vue?vue&type=script&setup=true&lang=js"
export * from "./proxy-control-config.vue?vue&type=script&setup=true&lang=js"
import style0 from "./proxy-control-config.vue?vue&type=style&index=0&id=c86d8c6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86d8c6e",
  null
  
)

export default component.exports